/* 🤖 this file was generated by script */
export const wsolidiconXCircle = {
  name: 'x_circle',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22m3.7 7.3a1 1 0 0 1 0 1.4L13.42 12l2.3 2.3a1 1 0 0 1-1.42 1.4L12 13.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L10.58 12l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 10.58l2.3-2.3a1 1 0 0 1 1.4 0" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
